<template>
  <general-layout v-if="canPerform('authcore.templates.list')">
    <loading-spinner v-if="!authenticated" />
    <b-container v-else>
      <b-row class="mb-5">
        <b-col>
          <h2>{{ $t('email_settings.title') }}</h2>
        </b-col>
      </b-row>
      <!-- <b-tabs
        class="mt-3"
        content-class="mt-3">
        <b-tab title="Provider" disabled />
        <b-tab title="Template" active> -->
      <b-row>
        <b-col class="mb-5">
          <b-form-group
            :label="$t('email_settings.input.label.language')"
          >
            <b-form-select
              v-model="selectedLanguage"
              :options="languages.map(language => {
                       return {
                       value: language.language,
                       text: $t(`languages.${language.language.toLowerCase()}`)
                       }
                       })"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-list-group>
            <b-list-group-item
              v-for="template in filteredTemplates"
              :key="template.key"
              class="generic-list-item"
            >
              <b-row align-v="end">
                <b-col>
                  <h5 class="mb-0">
                    <slot name="title">{{ template.name }}</slot>
                  </h5>
                  <div v-if="!template.updatedAt">
                    {{ $t('email_settings.text.default') }}
                  </div>
                  <div v-else>
                    {{ $t('email_settings.text.last_edited_on', { date: template.updatedAt }) }}
                  </div>
                </b-col>
                <b-col class="text-right" cols="auto">
                  <b-button
                    variant="outline-primary"
                    @click="openEditTemplateModel(template)">
                    {{ $t('email_settings.text.edit') }}
                  </b-button>
                </b-col>
              </b-row>
              <slot name="default"></slot>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-modal
        ref="modal"
        v-model="isEditTemplateModalEnabled"
        v-if="selectedTemplate && updatedTemplate"
        :title="$t('email_settings.modal.title', { name: selectedTemplate.name.toLowerCase() })"
        size="xl"
        scrollable
        hide-footer
      >
        <b-bsq-modal
          ref="bsq-modal"
          v-model="isSubModalEnabled"
          :header-title="modalHeaderTitle"
          :button-title="modalButtonTitle"
          :button-variant="modalButtonVariant"
          @ok="subModalSubmit"
        >
          <div class="mt-3 mb-5">
            <div v-if="isSubModalEnabled">
              {{ $t('email_settings.modal.text.restore_to_default_description') }}
            </div>
          </div>
        </b-bsq-modal>

        <b-alert
          v-if="isShowSuccessAlert"
          variant="success"
          show
        >
          {{ alertMessage }}
        </b-alert>
        <b-form>
          <!-- <b-bsq-input
            disabled
            separate
            label="Reply to"
            class="my-5 w-60"
          />
          <b-bsq-input
            disabled
            separate
            label="From"
            class="my-5 w-60"
          /> -->
          <b-bsq-input
            separate
            v-model="updatedTemplate.subject"
            :label="$t('email_settings.modal.input.label.subject')"
            class="my-5"
            input-class="font:0.875rem"
          />
          <b-row class="mb-4">
            <b-col>
              <div class="mb-3">{{ $t('email_settings.modal.input.label.text_template') }}</div>
              <b-form-textarea
                v-model="updatedTemplate.textTemplate"
                class="code-editor"
                rows="10"
                max-rows="20"
                variant="dark" />
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col>
              <div class="mb-3">{{ $t('email_settings.modal.input.label.html_template') }}</div>
              <b-form-textarea
                v-model="updatedTemplate.htmlTemplate"
                class="code-editor"
                rows="10"
                max-rows="20"
                variant="dark" />
            </b-col>
          </b-row>
          <b-button
            class="mr-3 px-5"
            variant="primary"
            @click="saveTemplate"
          >
            {{ $t('email_settings.modal.button.save') }}
          </b-button>
          <b-button
            id="restore-btn"
            class="px-5"
            variant="outline-danger"
            @click="restoreToDefaultTemplate"
          >
            {{ $t('email_settings.modal.button.restore_to_default') }}
          </b-button>
          <!-- <b-bsq-input
            disabled
            separate
            label="Test mail send to"
            class="my-5 w-60"
          />
          <b-button
            disabled
            variant="outline-primary">
            Send Test
          </b-button> -->
        </b-form>
      </b-modal>
        <!-- </b-tab>
      </b-tabs> -->
    </b-container>
  </general-layout>
</template>

<script>
import { mapState } from 'vuex'

import cloneDeep from 'lodash-es/cloneDeep'
import snakeCase from 'lodash-es/snakeCase'

import store from '@/store'
import i18n from '@/i18n'

import GeneralLayout from '@/components/GeneralLayout.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

export default {
  name: 'EmailTemplateSettings',
  components: {
    GeneralLayout,
    LoadingSpinner
  },

  computed: {
    ...mapState('client', [
      'authenticated'
    ]),
    ...mapState('management/templatesList', [
      'emailTemplates',
      'template',
      'languages'
    ]),
    filteredTemplates () {
      const newTemplates = this.emailTemplates
        // Fix item from this.emailTemplates. Not modifying this.emailTemplates
        // which should be from server.
        .map(item => Object.assign({}, item))
        .filter(template => template.language === this.selectedLanguage)
        .map(item => {
          item.key = item.name
          item.name = i18n.t(`email_settings.text.${snakeCase(item.name)}`)
          return item
        })
      return newTemplates
    },
    isShowSuccessAlert () {
      return this.isShowSuccessCreateAlert || this.isShowSuccessRestoreToDefaultAlert
    },
    alertMessage () {
      if (this.isShowSuccessCreateAlert) {
        return i18n.t('email_settings.modal.text.success_create')
      } else if (this.isShowSuccessRestoreToDefaultAlert) {
        return i18n.t('email_settings.modal.text.success_restore_to_default')
      }
      return ''
    },
    modalHeaderTitle () {
      return i18n.t('email_settings.modal.text.restore_to_default')
    },
    modalButtonTitle () {
      return i18n.t('email_settings.modal.button.confirm')
    },
    modalButtonVariant () {
      return 'danger'
    }
  },

  data () {
    return {
      cmOptions: {
        lint: true,
        indentUnit: 4,
        tabSize: 4,
        mode: 'text/html',
        gutters: ['CodeMirror-lint-markers'],
        lineNumbers: true,
        line: true,
        theme: 'base16-dark'
      },

      isEditTemplateModalEnabled: false,
      isShowSuccessCreateAlert: false,
      isShowSuccessRestoreToDefaultAlert: false,
      isSubModalEnabled: false,

      selectedLanguage: undefined,
      selectedTemplate: undefined,
      updatedTemplate: undefined
    }
  },

  watch: {
    template () {
      this.updatedTemplate = cloneDeep(this.template)
    },
    languages () {
      if (this.languages.length === 0) return
      this.selectedLanguage = this.languages[0].language
    },
    isEditTemplateModalEnabled (newVal) {
      // Remove alert flag when it is closed
      if (!newVal) {
        this.isShowSuccessCreateAlert = false
        this.isShowSuccessRestoreToDefaultAlert = false
      }
    }
  },

  mounted () {
    store.dispatch('management/templatesList/listEmailTemplates')
  },
  destroyed () {},

  methods: {
    modalScrollToTop () {
      this.$refs.modal.$refs.body.scrollTop = 0
    },
    async openEditTemplateModel (template) {
      this.isEditTemplateModalEnabled = true
      this.selectedTemplate = template
      this.isShowSuccessCreateAlert = false
      await store.dispatch('management/templatesList/getEmailTemplate', {
        language: this.selectedLanguage,
        name: this.selectedTemplate.key
      })
    },
    async saveTemplate () {
      const { subject, htmlTemplate, textTemplate } = this.updatedTemplate
      await store.dispatch('management/templatesList/createEmailTemplate', {
        language: this.selectedLanguage,
        name: this.selectedTemplate.key,
        subject,
        htmlTemplate,
        textTemplate
      })
      if (!this.actionError) {
        this.isShowSuccessCreateAlert = true
      }
      this.modalScrollToTop()
      // Keep update for the list
      await store.dispatch('management/templatesList/listEmailTemplates')
    },
    restoreToDefaultTemplate () {
      this.isSubModalEnabled = true
      // Unfocus the button to prevent scrolling when modal dismisses.
      document.getElementById('restore-btn').blur()
    },
    async subModalSubmit () {
      await store.dispatch('management/templatesList/restoreToDefaultEmailTemplate', {
        language: this.selectedLanguage,
        name: this.selectedTemplate.key
      })
      await store.dispatch('management/templatesList/getEmailTemplate', {
        language: this.selectedLanguage,
        name: this.selectedTemplate.key
      })
      if (!this.actionError) {
        this.$nextTick(() => {
          this.isSubModalEnabled = false
        })
        this.isShowSuccessRestoreToDefaultAlert = true
      }
      this.modalScrollToTop()
      // Keep update for the list
      await store.dispatch('management/templatesList/listEmailTemplates')
    }
  }
}
</script>

<style scoped>
.code-editor, .code-editor:focus {
  background-color: #000;
  color: #fff;
  font-family: 'PT Mono', monospace;
}
</style>
